import Dashboard from "..";

/** Dashboard → Overview sub-page: hero KPIs, messages activity, engagement funnel. */
const DashboardOverview = () => <Dashboard section="overview" />;

export default DashboardOverview;
